<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>杂费明细</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <!-- 搜索 -->
      <el-form :inline="true" size="small" v-model="listQuery">
      
       <el-form-item label="城市">
            <el-select v-model="listQuery.cityId" clearable placeholder="请选择城市" @change="cityChange">
              <el-option
                v-for="(item,index) in cityList"
                :key="index"
                :label="item.cityAddress"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务站">
            <el-select v-model="listQuery.stationId" clearable placeholder="请选择服务站">
              <el-option
                v-for="(item,index) in stationList"
                :key="index"
                :label="item.stationName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
           <el-form-item label="类型">
            <el-input v-model="listQuery.type" placeholder="请输入类型" clearable></el-input>
          </el-form-item>
         <el-form-item label="服务者">
            <el-input v-model="listQuery.workerName" placeholder="请输入服务者姓名" clearable></el-input>
          </el-form-item>
           <el-form-item label="手机号">
            <el-input v-model="listQuery.workerTel" placeholder="请输入手机号" clearable></el-input>
          </el-form-item>
           <el-form-item label="服务者工号">
            <el-input v-model="listQuery.serverNo" placeholder="请输入服务者工号" clearable></el-input>
          </el-form-item>
        <!-- <el-form-item label="时间段">
         <el-date-picker
              v-model="listQuery.timePart"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              value-format="yyyy-MM"
              :picker-options="pickerOptions"
              @change="dateChange"
            ></el-date-picker>
        </el-form-item> -->
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
           <a href="https://servant.lifejingzhi.com/file/salary/otherFeeTemplate.xlsx" download="新农保模板.xlsx">
          <el-button type="danger" icon="el-icon-download">杂费模版下载</el-button>
        </a>
        <el-button type="primary" icon="el-icon-upload2" @click="uploadBtn" v-per="'otherFeeImport'">杂费明细导入</el-button>
        </el-form-item>
      </el-form>

    
      <!-- 列表数据 -->
      <el-table :data="listData" border style="width: 100%" class="table">
        <el-table-column prop="id" label="ID"  width="50px"  fixed="left"></el-table-column>
  <el-table-column prop="serverId" label="编号" width="100px" fixed="left"></el-table-column>
        <el-table-column prop="name" label="姓名" ></el-table-column>
      
        <el-table-column prop="cityName" label="城市" ></el-table-column>
        <el-table-column prop="stationName" label="服务站"></el-table-column>
        <el-table-column prop="serverPhone" label="手机号"></el-table-column>
        <el-table-column prop="insuranceType" label="类型">
        
        </el-table-column>
           <el-table-column prop="subsidyDate" label="日期" :formatter="dateFormatA" width="140px"></el-table-column>
        <el-table-column prop="subsidyMonth" label="月份"></el-table-column>
        <el-table-column prop="subsidyFee" label="金额"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"  width="140px"></el-table-column>
        <!-- <el-table-column prop="updateTime" label="更新时间" :formatter="dateFormatA" width="140px"></el-table-column> -->
    
        <!-- <el-table-column prop label="操作" fixed="right" width="150px" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="showCategoryDetail(scope.row)">详情</el-button>

          </template>
        </el-table-column> -->
      </el-table>

      <!-- 分页 -->
      <pagination
        :total="total"
        :page.sync="currentPage"
        :limit.sync="pageSize"
        @pagination="querySearch"
      />
    </el-card>
   

   <el-dialog
      title="导入"
      :visible.sync="inputVisible"
      width="500px"
      :close-on-click-modal="false"
      center
    >
      <input type="file" @change="getFile($event)" ref="file" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="inputVisible = false">取 消</el-button>
        <el-button type="primary" @click="importConfirm">确 定</el-button>
      </span>
    </el-dialog>
 
  </div>
</template>
<script>
import moment from "moment";
import Pagination from "./common/Pagination";
import Service from "../script/api/service";
import globalData from "@/components/common/globaldata/global.data.vue";
export default {
  components: { Pagination },
  data() {
    return {
       inputVisible: false,
       file: "",
      cityList:[],
      stationList:[],
      listData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1, //当前页
      listQuery: {
        cityId:'',
        stationId:'',
        workerName:'',
        workerTel:'',
        type:'',
        serverNo:'',
        timePart: [],

      },
         pickerOptions: {
        shortcuts: [
          {
            text: "今年至今",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 12);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
   
    };
  },
  created() {
    this.cityList = JSON.parse(window.localStorage.getItem("allCityList"));
        if (!window.localStorage.getItem("allCityList")) {
        Service
          .$axiosGetAllCityStation({
            // userId:  JSON.parse(window.localStorage.getItem("userInfo")).id
          })
          .then(res => {
            if (res.data.errno == "0") {
                this.cityList ==res.data.data;
              window.localStorage.setItem("allCityList",JSON.stringify(this.cityList) );
            } else {
              this.$message.warning(res.data.errmsg);
            }

          })
      }
    this.querySearch();
  },
  methods: {
    //查询
    querySearch() {
      let temp = {
        page: this.currentPage,
        size: this.pageSize,
        cityId: this.listQuery.cityId,
        stationId: this.listQuery.stationId,
        name: this.listQuery.workerName,
        phone: this.listQuery.workerTel,
        serverNo:this.listQuery.serverNo,
        type:this.listQuery.type
      };
      // if (
      //   this.listQuery.timePart != "" &&
      //   this.listQuery.timePart != undefined
      // ) {
      //   temp.startMonth = moment(this.listQuery.timePart[0]).format("YYYY-MM");
      //   temp.endMonth = moment(this.listQuery.timePart[1]).format("YYYY-MM");
      // }

      Service.$axiosOtherFeeList(temp)
        .then(res => {
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch(err => {
          console.log(err);
        });
    },
    cityChange(value) {
      this.listQuery.stationId = '';
      let currentStation = this.cityList.filter(item => {
        return item.id == value;
      });
     this.stationList = currentStation[0].stationList;
    },
   dateChange(e) {
    
      if (e != null) {
        let start =
          new Date(e[0]).getFullYear() * 12 + new Date(e[0]).getMonth();
        let end = new Date(e[1]).getFullYear() * 12 + new Date(e[1]).getMonth();
        let isOvertime = end - start - 12 > 0;
        // if (isOvertime) {
        //   this.$message.warning("选中时间范围不能超过一年");
        //   this.listQuery.timePart = null;
        // }
      }
    },
     uploadBtn() {
      this.inputVisible = true;
      if (this.file != "") {
        this.$refs.file.value = "";
      }
    },
    getFile: function(event) {
      this.file = event.target.files[0];
    },
    importConfirm() {
      if (this.file== "") {
        this.$message.warning("请选择文件！");
        return;
      }
      var formData = new window.FormData(); // vue 中使用 window.FormData(),否则会报 'FormData isn't definded'
      formData.append("file", this.file);
      // formData.append("updateUser", globalData.userInfo.id);
      Service.$axiosImportOtherFee(formData)
        .then(res => {
          // console.log(res);
          if (res.data.errno == 0) {
            this.$message.success("杂费明细导入成功！");
            this.inputVisible = false;
            this.querySearch();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
   
 
  }
};
</script>
<style scoped>
.crumbs {
  margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}
</style>